define([
    "./nlgNullableCheckboxModule",
    "./nlgNullableCheckboxDirective"
], function () {
});